export function formatDate(date?: string | Date | null) {
  if (!date) return '-';
  if (date instanceof Date) return date.toLocaleString();

  if (typeof date === 'string') {
    if (!date.includes('Z') && !date.includes('+')) {
      const normalized = date.trim().replace(' ', 'T') + 'Z';
      const d = new Date(normalized);
      if (!isNaN(d.getTime())) return d.toLocaleString();
    }
    const d = new Date(date);
    if (!isNaN(d.getTime())) return d.toLocaleString();
  }
  return '-';
}

export const formatNumber = (val: number) => {
  return new Intl.NumberFormat('en-US', { useGrouping: true }).format(val)
}

/**
 * Format a numeric value with comma grouping while preserving every
 * significant digit — no rounding, no zero-padding, no truncation. Operates
 * on the raw string representation so that Postgres NUMERIC strings (returned
 * verbatim by Drizzle) keep full precision, and JS numbers go through
 * `.toString()` which gives a roundtrip-safe representation.
 *
 * Inputs we don't recognise as plain decimal notation (e.g. scientific
 * notation, or arbitrary text) are returned via String(...) untouched, so we
 * never reformat data we might silently mangle.
 */
const formatNoRound = (val: unknown): string => {
  if (val === null || val === undefined || val === '') return '-'

  let str: string
  if (typeof val === 'number') {
    if (!Number.isFinite(val)) return String(val)
    str = val.toString()
  } else if (typeof val === 'string') {
    str = val.trim()
    if (str === '') return '-'
  } else {
    return String(val)
  }

  if (!/^[+-]?(\d+\.?\d*|\.\d+)$/.test(str)) return String(val)

  let sign = ''
  if (str.startsWith('-')) { sign = '-'; str = str.slice(1) }
  else if (str.startsWith('+')) { str = str.slice(1) }

  let [intPart, decPart = ''] = str.split('.')
  intPart = intPart.replace(/^0+(?=\d)/, '') || '0'
  decPart = decPart.replace(/0+$/, '')

  const intGrouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return sign + intGrouped + (decPart ? '.' + decPart : '')
}

export const formatStockQuantity = (val: unknown) => formatNoRound(val)
export const formatStockQuantityAuto = (val: unknown) => formatNoRound(val)
